import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderFour from "../common/header/HeaderFour";
import SEO from "../common/SEO";
import ChatbotTwo from "./ChatbotTwo";
import Accelerate from "../component/individuals/Accelerate";
import Caliber from "../component/individuals/Caliber";
import TechTopics from "../component/individuals/TechTopics";
import Officials from "../component/individuals/Officials.js";

const Individuals = () => {
  return (
    <>
      <SEO />
      <main className="main-wrapper">
        <HeaderFour />
        <div className="section mt-4 section-padding">
          <Accelerate />
          <Caliber />
          <TechTopics />
          <Officials />
          <ChatbotTwo />
        </div>
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default Individuals;
